"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
var _lhJsEmailContentLib = require("@lifehikes/lh-js-email-content-lib");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _SupportedPlaceholders = _interopRequireDefault(require("../../hike/components/SupportedPlaceholders.vue"));
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LoopEmailSetting',
  components: {
    Tinymce: _Tinymce.default,
    SupportedPlaceholders: _SupportedPlaceholders.default
  },
  props: {
    parentId: {
      type: String,
      default: ""
    },
    parentAutomatedEmail: {
      type: Array,
      default: []
    },
    parentEmailRuleSet: {
      type: String,
      default: _lhJsEmailContentLib.ruleSetNames.HIKE_EMAIL_RULE_SET_GENERAL_HIKE
    }
  },
  data() {
    return {
      loading: false,
      haveLoop: false,
      emailSetting: []
    };
  },
  watch: {
    emailSetting: {
      handler(newVal) {
        const newEmailSetting = newVal.map(p => {
          if (p.remarks === "") {
            return {
              ruleName: p.name,
              subject: p.defaultSubject,
              content: p.defaultContent
            };
          }
        }).filter(p => p !== undefined);
        console.info('newEmailSetting');
        console.info(newEmailSetting);
        this.passBackToParent(newEmailSetting);
      },
      deep: true
    }
  },
  async created() {
    this.emailRuleSet = this.parentEmailRuleSet;
    // this.emailSetting = this.parentAutomatedEmail;
    this.initEmailSetting();
  },
  methods: {
    initEmailSetting() {
      this.emailSetting = [];
      const item = _lhJsEmailContentLib.ruleNames.SCHEDULED_EMAIL_RULE_LOOP_ENROLLMENT;
      const emailSetting = (0, _lhJsEmailContentLib.getEmailRuleSettings)(item);
      const parentEmailSetting = this.parentAutomatedEmail.find(p => p.ruleName === item);
      if (parentEmailSetting !== null && parentEmailSetting !== undefined) {
        emailSetting.defaultSubject = parentEmailSetting.subject;
        emailSetting.defaultContent = parentEmailSetting.content;
      }
      emailSetting.name = item;
      emailSetting.showPlaceholders = false;
      let remarks = '';
      // if (this.haveLoop) {
      // 	if (!emailSetting.enableWhenHikeInLoop) {
      // 		remarks = "It will not trigger because the Hike is within a Loop.";
      // 	}
      // } else {
      // 	if (!emailSetting.enableWhenHikeNotInLoop) {
      // 		remarks = "It will not trigger because the Hike is not within a Loop.";
      // 	}
      // }
      emailSetting.remarks = remarks;
      console.log(emailSetting);
      this.emailSetting.push(emailSetting);
    },
    ruleSettingChange() {
      this.initEmailSetting();
    },
    resetSubjectContent(name, index) {
      const defaultEmailSetting = (0, _lhJsEmailContentLib.getEmailRuleSettings)(name);
      let currentSetting = this.emailSetting[index];
      currentSetting.defaultSubject = defaultEmailSetting.defaultSubject;
      currentSetting.defaultContent = defaultEmailSetting.defaultContent;
      //this.$set(this.emailSetting, index, currentSetting)
      //Fixed the tinymce editor reset update ui bug
      this.$nextTick(() => window.tinymce.get('descriptionEditor' + index).setContent(currentSetting.defaultContent || ''));
    },
    switchPlaceholders(showPlaceholders, index) {
      let currentSetting = this.emailSetting[index];
      currentSetting.showPlaceholders = showPlaceholders;
    },
    passBackToParent(res) {
      this.$emit("updateParentEmailRuleSet", res);
    }
  }
};